<template>
  <OnClickOutside @trigger="foldMenu">
    <div id="hubSelector" ref="selectContainer">
      <div class="select-row link" ref="selectDropDown" @click="listToggle" @keypress.enter="listToggle">
        <div class="value-input">{{ selectedData ? selectedData[valueKey] : null }}</div>
        <div class="dropdown-button" />
      </div>
      <div
        class="option-list"
        v-if="listShow"
        v-bind:style="{
          top: listTop,
          bottom: listBottom,
          height: listHeight,
          left: listLeft,
          right: listRight,
          minWidth: listMinWidth,
        }"
      >
        <ul ref="selectOptionList">
          <li
            v-for="(data, index) in dataList"
            v-bind:key="data[codeKey] || index"
            @click="selectOption(data)"
            @keypress.enter="selectOption(data)"
            class="option"
          >
            {{ data[valueKey] }}
          </li>
        </ul>
      </div>
    </div>
  </OnClickOutside>
</template>

<script>
import { OnClickOutside } from '@vueuse/components';

export default {
  props: ['optionList', 'code', 'label', 'selectedKey', 'onChange'],
  data() {
    return {
      listShow: false,
      selectedData: null,
      dataList: [],
      codeKey: 'id',
      valueKey: 'name',

      listTop: '',
      listBottom: '',
      listHeight: '',
      listLeft: '',
      listRight: '',
      listMinWidth: '',
    };
  },

  components: {
    OnClickOutside,
  },

  created() {
    this.codeKey = this.code || this.codeKey;
    this.valueKey = this.label || this.valueKey;
    this.loadList();
  },

  methods: {
    loadList() {
      this.dataList = [];

      this.optionList.forEach((option) => {
        const wrappedOption = {};

        if (Object.keys(option).length === 1) {
          [wrappedOption[this.codeKey]] = Object.keys(option);
          wrappedOption[this.valueKey] = option[wrappedOption[this.codeKey]];
        } else {
          wrappedOption[this.codeKey] = option.id;
          wrappedOption[this.valueKey] = option.name;
        }

        this.dataList.push(wrappedOption);
      });

      this.selectedData = this.dataList.find((option) => Number(option[this.codeKey]) === Number(this.selectedKey));

      this.selectedData = this.selectedData || this.dataList[0];
    },
    listToggle() {
      this.listShow = !this.listShow;

      if (this.listShow) {
        this.$nextTick(() => {
          this.placeList();
        });
      }
    },
    placeList() {
      // Vertical dimensions
      const screenClientHeight = this.$refs.selectContainer.ownerDocument.documentElement.clientHeight;
      const rectBottom = this.$refs.selectContainer.getBoundingClientRect().bottom;
      const bottomDistance = screenClientHeight - rectBottom;
      const topDistance = this.$refs.selectContainer.getBoundingClientRect().top;

      // Horizontal dimensions
      const screenClientWidth = this.$refs.selectContainer.ownerDocument.documentElement.clientWidth;
      const leftDistance = this.$refs.selectContainer.getBoundingClientRect().left;
      const selectorClientWidth = this.$refs.selectContainer.getBoundingClientRect().width;

      // Reset or dynamic styles
      this.listHeight = '';
      this.listMinWidth = '';
      this.listTop = '';
      this.listBottom = '';
      this.listLeft = '';
      this.listRight = '';

      this.$nextTick(() => {
        // Vertical calculation
        const listClientHeight = this.$refs.selectOptionList.getBoundingClientRect().height;

        if (bottomDistance > 0.4 * screenClientHeight) {
          if (bottomDistance - 13 < listClientHeight) {
            this.listHeight = `${bottomDistance - 13}px`;
          }

          this.listTop = 'calc(100% + 1px)';
        } else {
          if (topDistance - 13 < listClientHeight) {
            this.listHeight = `${topDistance - 13}px`;
          }

          this.listBottom = 'calc(100% + 1px)';
        }

        // Horizontal calculation
        const listClientWidth = this.$refs.selectOptionList.getBoundingClientRect().width;

        this.listMinWidth = `${selectorClientWidth}px`;

        if (leftDistance + listClientWidth > screenClientWidth) {
          this.listRight = '0';
        }
      });
    },
    selectOption(data) {
      if (data !== this.selectedData) {
        this.onChange(data);
      }

      this.selectedData = data;
      this.listShow = false;
    },
    foldMenu() {
      this.listShow = false;
    },
  },

  watch: {
    optionList(val) {
      if (val.length > 0) {
        this.loadList();
      }
    },
  },
};
</script>

<style scoped>
#hubSelector {
  display: inline-flex;
  flex-direction: column;
  position: relative;
  /** Fit mobile width */
  /* min-width: 240px;  */
  width: 100%;
  cursor: pointer;
}

#hubSelector .select-row {
  display: flex;
  align-items: center;
  border: 1px solid #a7a9ac;
  border-radius: 5px;
  box-sizing: border-box;
}
#hubSelector .value-input {
  flex: 1;
  margin: 0 1em;
  height: 2.5em;
  line-height: 2.5em;
  text-align: left;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
#hubSelector .dropdown-button {
  margin: 0 1em 0 0;
  width: 0.8em;
  height: 0.8em;
  border-bottom: 2px solid #6d6e71;
  border-left: 2px solid #6d6e71;
  transform: translateY(-0.2em) rotate(-45deg);
}

#hubSelector .option-list {
  position: absolute;
  border: 1px solid #a7a9ac;
  border-radius: 0.4em;
  box-shadow: 0 0 0.8em 0 #a7a9ac;
  overflow: hidden;
  z-index: 1;
}

#hubSelector .option-list ul {
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
}

#hubSelector .option-list .option {
  /* white-space: nowrap; */
  padding: 0.8em 1em;
  background-color: #ffffff;
  text-align: left;
  transition: background-color 0.3s, color 0.3s;
}
#hubSelector .option-list .option:not(:last-child) {
  border-bottom: 1px solid #a7a9ac;
}
#hubSelector .option-list .option:hover {
  background-color: #8ac640;
  color: #ffffff;
}
</style>
